import { newAmount } from '@orus.eu/amount'
import { nbsp } from '@orus.eu/char'

import { createPolicyItemConfigurationResolver } from '../../../model/policy-item-configuration.ts'
import type { PolicyItems } from '../../../model/policy-item.ts'
import type { EsMrpaxePolicyItem, EsMrpaxePolicyItemsState } from '../es-mrpaxe-insurance.ts'

export const esMrpaxePolicyItems_V1_0_0 = {
  building: {
    name: 'building',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [
        newAmount(15_000),
        newAmount(30_000),
        newAmount(50_000),
        newAmount(75_000),
        newAmount(100_000),
        newAmount(125_000),
        newAmount(150_000),
        newAmount(200_000),
      ],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  stock: {
    name: 'stock',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'variableAmount',
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  water: {
    name: 'water',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: { type: 'text', value: `100${nbsp}% del capital asegurado de cada categoría` },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  theft: {
    name: 'theft',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: { type: 'text', value: `100${nbsp}% del capital asegurado de cada categoría` },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  cash_theft: {
    name: 'cash_theft',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(250), newAmount(600)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: ['theft'],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: true,
        canBeUpdated: false,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  vandalism: {
    name: 'vandalism',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(500), newAmount(1_500)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: true,
        canBeUpdated: false,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  glass_breakage: {
    name: 'glass_breakage',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: { type: 'text', value: `100${nbsp}% del capital asegurado de cada categoría` },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  machine_breakage: {
    name: 'machine_breakage',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [
        newAmount(1_500),
        newAmount(3_000),
        newAmount(6_000),
        newAmount(10_000),
        newAmount(15_000),
        newAmount(20_000),
      ],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  computer_breakage: {
    name: 'computer_breakage',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(1_500), newAmount(3_000), newAmount(6_000)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: true,
        canBeUpdated: false,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  transported_goods_theft: {
    name: 'transported_goods_theft',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(2_500), newAmount(6_000)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: ['stock'],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: true,
        canBeUpdated: false,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  temp_controlled_goods: {
    name: 'temp_controlled_goods',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(2_000), newAmount(3_000), newAmount(6_000), newAmount(15_000)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: ['stock'],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  todo_riesgo_accidental: {
    name: 'todo_riesgo_accidental',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: { type: 'text', value: `100${nbsp}% del capital asegurado de cada categoría` },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: true,
        canBeUpdated: false,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  bi: {
    name: 'bi',
    type: 'guarantee',
    optionality: ['optional'],
    // Cobertura diaria: 250/500/750/1000/1500 €
    // Duración máxima: 1/2/3/6/9/12 meses
    possibleLimitOfIndemnities: {
      type: 'amountPerDuration',
      amounts: [newAmount(250), newAmount(500), newAmount(750), newAmount(1_000), newAmount(1_500)],
      durations: [1, 2, 3, 6, 9, 12],
    },
    possibleDeductibles: { type: 'fixedTimeInDays', value: 3 },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  occ_liability: {
    name: 'occ_liability',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(150_000), newAmount(300_000), newAmount(450_000), newAmount(600_000), newAmount(1_000_000)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: true,
        canBeUpdated: false,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  public_liability: {
    name: 'public_liability',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(150_000), newAmount(300_000), newAmount(450_000), newAmount(600_000), newAmount(1_000_000)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: true,
        canBeUpdated: false,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  employer_liability: {
    name: 'employer_liability',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(150_000), newAmount(300_000), newAmount(450_000), newAmount(600_000), newAmount(1_000_000)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: true,
        canBeUpdated: false,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
  pro_product_liability: {
    name: 'pro_product_liability',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [newAmount(150_000), newAmount(300_000), newAmount(450_000), newAmount(600_000), newAmount(1_000_000)],
    },
    possibleDeductibles: { type: 'calculatedAmount' },
    dependsOn: [],
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
  },
} as const satisfies PolicyItems<EsMrpaxePolicyItem, EsMrpaxePolicyItemsState>
